import { useRef } from "react";
import { STEP } from "../src/pane-layout.ts";

/*
 * The list's draggable right edge. Pointer capture keeps the drag on the divider even over an email's
 * iframe; for keyboard use the arrow keys move it by STEP, ArrowRight widening the list.
 */
export function PaneDivider(props: {
  label: string;
  className: string;
  value: number;
  min: number;
  max: number;
  fromPointer: (clientX: number) => number;
  onResize: (width: number, done: boolean) => void;
}) {
  const dragging = useRef(false);
  const end = (event: React.PointerEvent<HTMLDivElement>): void => {
    if (!dragging.current) return;
    dragging.current = false;
    document.documentElement.classList.remove("lcr-resizing");
    props.onResize(props.fromPointer(event.clientX), true);
  };
  return (
    // biome-ignore lint/a11y/useSemanticElements: a focusable, adjustable separator has no native element.
    <div
      role="separator"
      aria-orientation="vertical"
      aria-label={props.label}
      aria-valuenow={props.value}
      aria-valuemin={props.min}
      aria-valuemax={props.max}
      tabIndex={0}
      className={`lcr-divider ${props.className}`}
      onPointerDown={(event) => {
        if (event.button !== 0) return;
        event.preventDefault();
        event.currentTarget.setPointerCapture(event.pointerId);
        dragging.current = true;
        document.documentElement.classList.add("lcr-resizing");
      }}
      onPointerMove={(event) => {
        if (dragging.current) props.onResize(props.fromPointer(event.clientX), false);
      }}
      onPointerUp={end}
      onPointerCancel={end}
      onKeyDown={(event) => {
        if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
        event.preventDefault();
        props.onResize(props.value + (event.key === "ArrowRight" ? STEP : -STEP), true);
      }}
    />
  );
}
